const translations = {
  en: {
    // Header
    home: 'Home',
    experiences: 'Experiences',
    destinations: 'Destinations',
    about: 'About',
    contact: 'Contact',
    requestItinerary: 'Request Itinerary',
    
    // Hero
    heroTitle: 'Peace of Mind Trips and Travels',
    heroSubtitle: 'Explore India with Heart',
    heroTagline: 'Travel. Learn. Transform.',
    startJourney: 'Start Your Journey',
    
    // About
    aboutTitle: 'Our Story',
    aboutQuote: 'India is not a place you see. It\'s a place you feel.',
    aboutText: 'At POMTrips, we believe travel is not just about seeing destinations—it\'s about experiencing energy, culture, and transformation. We curate journeys that blend India\'s rich heritage, wellness practices, and sustainable tourism to create meaningful connections.',
    readMore: 'Read More',
    
    // Experiences
    experiencesTitle: 'Little India Collection',
    experiencesSubtitle: 'Discover Transformative Experiences',
    heritageTitle: 'Heritage & Culture',
    heritageDesc: 'Ancient monuments whisper stories of dynasties past',
    wellnessTitle: 'Yoga & Wellness',
    wellnessDesc: 'Find peace through ancient practices by sacred rivers',
    natureTitle: 'Nature & Wildlife',
    natureDesc: 'Where tigers roam and the earth breathes life',
    artisansTitle: 'Artisans & Communities',
    artisansDesc: 'Meet the hands that weave India\'s cultural fabric',
    vrTitle: 'VR India Experience',
    vrDesc: 'Travel from anywhere—immersive virtual journeys',
    
    // Destinations
    destinationsTitle: 'Our Destinations',
    destinationsSubtitle: 'Explore the Heart of India',
    delhiTitle: 'Delhi',
    delhiDesc: 'Where centuries collide in vibrant harmony',
    agraTitle: 'Agra',
    agraDesc: 'Home to eternal love, carved in white marble',
    rishikeshTitle: 'Rishikesh',
    rishikeshDesc: 'Where stories rise with the mist of the Ganga',
    gwaliorTitle: 'Gwalior',
    gwaliorDesc: 'Forts that touch the sky, music that touches the soul',
    corbettTitle: 'Jim Corbett',
    corbettDesc: 'Wild heartbeats echo through ancient forests',
    chambalTitle: 'Chambal Safari',
    chambalDesc: 'Where gharials glide through untamed waters',
    
    // Sustainability
    sustainabilityTitle: 'Travel Responsibly',
    sustainabilityQuote: 'Leave a legacy of peace',
    sustainabilityText: 'We partner with local communities, support traditional artisans, and practice eco-conscious tourism. Every journey with POMTrips contributes to preserving India\'s cultural heritage and natural beauty for generations to come.',
    
    // Testimonials
    testimonialsTitle: 'Travelers Stories',
    testimonial1: '"Manish is very friendly and he advised and guided me on my entire stay in India. If not for him I would have missed Jaipur. POMTrips arranged my entire itinerary in India without any additional costs. I feel I made a friend for life. Thank you Manish. Namaste!"',
    testimonial1Author: 'Himmy Abader',
    testimonial1Role: 'Architect, South Africa',
    testimonial2: '"An unforgettable journey through India\'s spiritual heart. The yoga retreat in Rishikesh was transformative, and every detail was thoughtfully arranged."',
    testimonial2Author: 'Sarah Mitchell',
    testimonial2Role: 'Wellness Coach, USA',
    testimonial3: '"POMTrips showed us the real India—beyond tourist spots. Meeting local artisans and experiencing authentic culture made this our most meaningful trip ever."',
    testimonial3Author: 'Marco Rodriguez',
    testimonial3Role: 'Photographer, Spain',
    
    // CTA
    ctaTitle: 'Your Journey of Peace Begins Here',
    ctaButton: 'Plan with Us',
    
    // Form
    formTitle: 'Request Your Custom Itinerary',
    formName: 'Full Name',
    formEmail: 'Email Address',
    formPhone: 'Phone Number',
    formDates: 'Preferred Travel Dates',
    formInterests: 'Interests',
    formMessage: 'Tell us about your dream journey',
    formSubmit: 'Send Request',
    formSuccess: 'Thank you! We\'ll contact you within 24 hours.',
    
    // Footer
    footerTagline: 'Explore India with Heart',
    footerAbout: 'About POMTrips',
    footerQuickLinks: 'Quick Links',
    footerContact: 'Contact Us',
    footerAddress: '250/13, Than Singh Nagar, New Delhi, 110005, India',
    footerCopyright: '© 2025 Peace of Mind Trips & Travels. All rights reserved.',
    chatWithUs: 'Chat with us on WhatsApp',
    
    // Why Choose
    whyChooseTitle: 'Why Choose POMTrips?',
    transparency: 'Transparency',
    transparencyDesc: 'Clear pricing, no hidden costs',
    handmade: 'Handmade Itineraries',
    handmadeDesc: 'Personalized journeys crafted for you',
    virtualTours: 'Virtual Tours',
    virtualToursDesc: 'Experience India from anywhere',
    soloFriendly: 'Solo Traveler Friendly',
    soloFriendlyDesc: 'Safe, welcoming, transformative'
  },
  es: {
    // Header
    home: 'Inicio',
    experiences: 'Experiencias',
    destinations: 'Destinos',
    about: 'Sobre Nosotros',
    contact: 'Contacto',
    requestItinerary: 'Solicitar Itinerario',
    
    // Hero
    heroTitle: 'Viajes y Viajes Peace of Mind',
    heroSubtitle: 'Explora India con el Corazón',
    heroTagline: 'Viajar. Aprender. Transformar.',
    startJourney: 'Comienza Tu Viaje',
    
    // About
    aboutTitle: 'Nuestra Historia',
    aboutQuote: 'India no es un lugar que ves. Es un lugar que sientes.',
    aboutText: 'En POMTrips, creemos que viajar no se trata solo de ver destinos, sino de experimentar energía, cultura y transformación. Creamos viajes que combinan la rica herencia de India, prácticas de bienestar y turismo sostenible para crear conexiones significativas.',
    readMore: 'Leer Más',
    
    // Experiences
    experiencesTitle: 'Colección Little India',
    experiencesSubtitle: 'Descubre Experiencias Transformadoras',
    heritageTitle: 'Patrimonio y Cultura',
    heritageDesc: 'Monumentos antiguos susurran historias de dinastías pasadas',
    wellnessTitle: 'Yoga y Bienestar',
    wellnessDesc: 'Encuentra paz a través de prácticas antiguas junto a ríos sagrados',
    natureTitle: 'Naturaleza y Vida Silvestre',
    natureDesc: 'Donde los tigres deambulan y la tierra respira vida',
    artisansTitle: 'Artesanos y Comunidades',
    artisansDesc: 'Conoce las manos que tejen el tejido cultural de India',
    vrTitle: 'Experiencia VR India',
    vrDesc: 'Viaja desde cualquier lugar: viajes virtuales inmersivos',
    
    // Destinations
    destinationsTitle: 'Nuestros Destinos',
    destinationsSubtitle: 'Explora el Corazón de India',
    delhiTitle: 'Delhi',
    delhiDesc: 'Donde los siglos chocan en vibrante armonía',
    agraTitle: 'Agra',
    agraDesc: 'Hogar del amor eterno, tallado en mármol blanco',
    rishikeshTitle: 'Rishikesh',
    rishikeshDesc: 'Donde las historias surgen con la niebla del Ganga',
    gwaliorTitle: 'Gwalior',
    gwaliorDesc: 'Fortalezas que tocan el cielo, música que toca el alma',
    corbettTitle: 'Jim Corbett',
    corbettDesc: 'Latidos salvajes resuenan a través de bosques antiguos',
    chambalTitle: 'Safari Chambal',
    chambalDesc: 'Donde los gaviales se deslizan por aguas indómitas',
    
    // Sustainability
    sustainabilityTitle: 'Viaja Responsablemente',
    sustainabilityQuote: 'Deja un legado de paz',
    sustainabilityText: 'Nos asociamos con comunidades locales, apoyamos artesanos tradicionales y practicamos turismo eco-consciente. Cada viaje con POMTrips contribuye a preservar el patrimonio cultural y la belleza natural de India para las generaciones futuras.',
    
    // Testimonials
    testimonialsTitle: 'Historias de Viajeros',
    testimonial1: '"Manish es muy amigable y me asesoró en toda mi estadía en India. Si no fuera por él, me habría perdido Jaipur. POMTrips organizó todo mi itinerario en India sin costos adicionales. Siento que hice un amigo para toda la vida. ¡Gracias Manish! ¡Namaste!"',
    testimonial1Author: 'Himmy Abader',
    testimonial1Role: 'Arquitecto, Sudáfrica',
    testimonial2: '"Un viaje inolvidable por el corazón espiritual de India. El retiro de yoga en Rishikesh fue transformador, y cada detalle fue cuidadosamente organizado."',
    testimonial2Author: 'Sarah Mitchell',
    testimonial2Role: 'Coach de Bienestar, EE.UU.',
    testimonial3: '"POMTrips nos mostró la verdadera India, más allá de los lugares turísticos. Conocer artesanos locales y experimentar la cultura auténtica hizo de este nuestro viaje más significativo."',
    testimonial3Author: 'Marco Rodriguez',
    testimonial3Role: 'Fotógrafo, España',
    
    // CTA
    ctaTitle: 'Tu Viaje de Paz Comienza Aquí',
    ctaButton: 'Planifica con Nosotros',
    
    // Form
    formTitle: 'Solicita Tu Itinerario Personalizado',
    formName: 'Nombre Completo',
    formEmail: 'Correo Electrónico',
    formPhone: 'Número de Teléfono',
    formDates: 'Fechas Preferidas de Viaje',
    formInterests: 'Intereses',
    formMessage: 'Cuéntanos sobre tu viaje soñado',
    formSubmit: 'Enviar Solicitud',
    formSuccess: '¡Gracias! Te contactaremos en 24 horas.',
    
    // Footer
    footerTagline: 'Explora India con el Corazón',
    footerAbout: 'Sobre POMTrips',
    footerQuickLinks: 'Enlaces Rápidos',
    footerContact: 'Contáctanos',
    footerAddress: '250/13, Than Singh Nagar, Nueva Delhi, 110005, India',
    footerCopyright: '© 2025 Peace of Mind Trips & Travels. Todos los derechos reservados.',
    chatWithUs: 'Chatea con nosotros en WhatsApp',
    
    // Why Choose
    whyChooseTitle: '¿Por Qué Elegir POMTrips?',
    transparency: 'Transparencia',
    transparencyDesc: 'Precios claros, sin costos ocultos',
    handmade: 'Itinerarios Hechos a Mano',
    handmadeDesc: 'Viajes personalizados creados para ti',
    virtualTours: 'Tours Virtuales',
    virtualToursDesc: 'Experimenta India desde cualquier lugar',
    soloFriendly: 'Amigable para Viajeros Solos',
    soloFriendlyDesc: 'Seguro, acogedor, transformador'
  }
};

export default translations;